// Reconstructed from the supplied production build; original component names were unavailable.
import { React, jsxRuntime, useNavigate } from "../../vendor/runtime.js";
import { useAuth } from "../../context/AuthContext.jsx";
import { API_BASE_URL } from "../../config.js";
import { ForgotPasswordForm } from "./ForgotPasswordForm.jsx";
import { RegisterInput } from "./RegisterInput.jsx";
const RegisterForm = () => {
  const [a, n] = React.useState(false),
    [i, l] = React.useState(false),
    [c, u] = React.useState({
      email: "",
      password: "",
    }),
    [m, f] = React.useState({}),
    [x, p] = React.useState(false),
    [g, b] = React.useState({
      name: "",
      phone: "",
      email: "",
      password: "",
      confirmPassword: "",
    }),
    [y, w] = React.useState({}),
    [N, T] = React.useState(false),
    { login: C, register: A } = useAuth(),
    O = useNavigate(),
    M = (L) => {
      (u({
        ...c,
        [L.target.name]: L.target.value,
      }),
        m[L.target.name] &&
          f({
            ...m,
            [L.target.name]: "",
          }));
    },
    Y = () => {
      const L = {};
      return (
        c.email
          ? /\S+@\S+\.\S+/.test(c.email) || (L.email = "Email is invalid")
          : (L.email = "Email is required"),
        c.password || (L.password = "Password is required"),
        f(L),
        Object.keys(L).length === 0
      );
    },
    R = async (L) => {
      if ((L.preventDefault(), !!Y())) {
        p(true);
        try {
          (await C(c.email, c.password)).success && O("/");
        } catch (X) {
          (console.error("Login error:", X),
            X.needVerification
              ? O("/verify", {
                  state: {
                    userId: X.userId,
                    email: c.email,
                  },
                })
              : f({
                  ...m,
                  general: X.message || "Login failed",
                }));
        } finally {
          p(false);
        }
      }
    },
    U = (L) => {
      const { name: X, value: se } = L.target;
      let re = se;
      (X === "phone" && ((re = se.replace(/\D/g, "")), re.length > 10)) ||
        (b({
          ...g,
          [X]: re,
        }),
        y[X] &&
          w({
            ...y,
            [X]: "",
          }));
    },
    W = () => {
      const L = {};
      return (
        g.name.trim() || (L.name = "Name is required"),
        g.phone
          ? g.phone.length < 10 && (L.phone = "Enter your 10digit mobile number without +91")
          : (L.phone = "Phone is required"),
        g.email
          ? /\S+@\S+\.\S+/.test(g.email) || (L.email = "Email is invalid")
          : (L.email = "Email is required"),
        g.password
          ? g.password.length < 6 && (L.password = "Password must be at least 6 characters")
          : (L.password = "Password is required"),
        g.password !== g.confirmPassword && (L.confirmPassword = "Passwords do not match"),
        w(L),
        Object.keys(L).length === 0
      );
    },
    B = async (L) => {
      if ((L.preventDefault(), console.log(g.name, g.phone, g.email, g.password), !!W())) {
        T(true);
        try {
          const X = await A(g.name, g.phone, g.email, g.password);
          X.success &&
            (X.requiresVerification === false
              ? O("/login", {
                  state: {
                    registrationSuccess: true,
                    message: X.message,
                  },
                })
              : O("/verify", {
                  state: {
                    userId: X.userId,
                    email: g.email,
                  },
                }));
        } catch (X) {
          (console.error("Registration error:", X),
            w({
              ...y,
              general: X.message || "Registration failed",
            }));
        } finally {
          T(false);
        }
      }
    },
    G = () => {
      window.location.href = API_BASE_URL + "/auth/google";
    },
    te = () => {
      n(true);
    },
    ne = () => {
      n(false);
    },
    de = () => (
      <svg className={"w-full h-full"} fill={"none"} stroke={"currentColor"} viewBox={"0 0 24 24"}>
        <path
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"2"}
          d={
            "M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
          }
        />
      </svg>
    ),
    Me = () => (
      <svg className={"w-full h-full"} fill={"none"} stroke={"currentColor"} viewBox={"0 0 24 24"}>
        <path
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"2"}
          d={
            "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          }
        />
      </svg>
    ),
    Ce = () => (
      <svg className={"w-full h-full"} fill={"none"} stroke={"currentColor"} viewBox={"0 0 24 24"}>
        <path
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"2"}
          d={"M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"}
        />
      </svg>
    ),
    we = () => (
      <svg className={"w-full h-full"} fill={"none"} stroke={"currentColor"} viewBox={"0 0 24 24"}>
        <path
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"2"}
          d={
            "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          }
        />
      </svg>
    );
  return a ? (
    <div
      className={
        "min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-4"
      }
    >
      <ForgotPasswordForm onBack={ne} onSuccess={ne} />
    </div>
  ) : (
    <div
      className={
        "min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-2 md:p-4"
      }
    >
      <style jsx={true}>{`
        @keyframes slideInLeft {
          from {
            transform: translateX(-10px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes fadeInUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slideInLeft {
          animation: slideInLeft 0.3s ease-out;
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.5s ease-out;
        }
      `}</style>
      <div
        className={
          "relative bg-white rounded-2xl md:rounded-3xl shadow-2xl overflow-hidden w-full max-w-sm md:max-w-md xl:max-w-5xl h-[100vh] max-h-[650px] md:max-h-[600px] xl:min-h-[700px] animate-fadeInUp"
        }
      >
        <div className={"xl:hidden h-full"}>
          <div
            className={`absolute top-0 h-full w-full transition-all duration-700 ease-in-out ${i ? "opacity-0 z-10 transform translate-x-full" : "opacity-100 z-50 transform translate-x-0"}`}
          >
            <div className={"bg-white flex flex-col h-full"}>
              <div
                className={
                  "bg-gradient-to-r from-indigo-600 to-purple-600 p-3 md:p-4 text-center text-white flex-shrink-0"
                }
              >
                <img
                  src={"/Logo.webp"}
                  alt={"code bro , codebruh"}
                  className={"h-12 w-12 md:h-16 md:w-16 mx-auto mb-1"}
                />
                <h1 className={"text-sm md:text-lg font-bold"}>{"Create Account"}</h1>
                <p className={"text-indigo-100 text-xs md:text-sm mt-1"}>{"Join us today"}</p>
              </div>
              <div className={"flex-1 p-3 md:p-4 flex flex-col min-h-0"}>
                <div className={"flex-1 flex flex-col justify-center"}>
                  {y.general && (
                    <div
                      className={
                        "bg-red-50 border border-red-200 text-red-700 px-2 py-2 md:px-3 md:py-2 rounded-lg mb-3 text-xs animate-slideInLeft"
                      }
                    >
                      <div className={"flex items-center"}>
                        <svg
                          className={"w-3 h-3 mr-1 flex-shrink-0"}
                          fill={"currentColor"}
                          viewBox={"0 0 20 20"}
                        >
                          <path
                            fillRule={"evenodd"}
                            d={
                              "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                            }
                            clipRule={"evenodd"}
                          />
                        </svg>
                        {y.general}
                      </div>
                    </div>
                  )}
                  <form onSubmit={B} className={"space-y-3"}>
                    <RegisterInput
                      type={"text"}
                      name={"name"}
                      placeholder={"Full Name"}
                      value={g.name}
                      onChange={U}
                      error={y.name}
                      icon={<Ce />}
                    />
                    <RegisterInput
                      type={"tel"}
                      name={"phone"}
                      placeholder={"Phone Number"}
                      value={g.phone}
                      onChange={U}
                      error={y.phone}
                      icon={jsxRuntime.jsx(we, {})}
                    />
                    <RegisterInput
                      type={"email"}
                      name={"email"}
                      placeholder={"Email Address"}
                      value={g.email}
                      onChange={U}
                      error={y.email}
                      icon={jsxRuntime.jsx(de, {})}
                    />
                    <RegisterInput
                      type={"password"}
                      name={"password"}
                      placeholder={"Password"}
                      value={g.password}
                      onChange={U}
                      error={y.password}
                      icon={<Me />}
                    />
                    <RegisterInput
                      type={"password"}
                      name={"confirmPassword"}
                      placeholder={"Confirm Password"}
                      value={g.confirmPassword}
                      onChange={U}
                      error={y.confirmPassword}
                      icon={<Me />}
                    />
                    <div className={"pt-3"}>
                      <button
                        type={"submit"}
                        disabled={N}
                        className={
                          "w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold py-3 md:py-3 px-4 rounded-full text-xs md:text-sm uppercase tracking-wider transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                        }
                      >
                        {N ? (
                          <div className={"flex items-center justify-center"}>
                            <svg
                              className={"animate-spin -ml-1 mr-2 h-3 w-3 md:h-4 md:w-4 text-white"}
                              fill={"none"}
                              viewBox={"0 0 24 24"}
                            >
                              <circle
                                className={"opacity-25"}
                                cx={"12"}
                                cy={"12"}
                                r={"10"}
                                stroke={"currentColor"}
                                strokeWidth={"4"}
                              />
                              <path
                                className={"opacity-75"}
                                fill={"currentColor"}
                                d={
                                  "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                }
                              />
                            </svg>
                            {"Creating..."}
                          </div>
                        ) : (
                          "Sign Up"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div
                  className={
                    "pt-6 pb-3 flex-shrink-0 bg-gray-50 mx-[-12px] md:mx-[-16px] px-3 md:px-4"
                  }
                >
                  <div className={"text-center"}>
                    <p className={"text-gray-600 text-sm md:text-base mb-2"}>
                      {"Already have an account?"}
                    </p>
                    <button
                      onClick={() => l(true)}
                      className={
                        "text-indigo-600 font-bold text-sm md:text-base hover:text-indigo-800 transition-colors transform hover:scale-105 active:scale-95 px-6 py-2 rounded-full border-2 border-indigo-600 hover:bg-indigo-50"
                      }
                    >
                      {"Sign In"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`absolute top-0 h-full w-full z-20 transition-all duration-700 ease-in-out ${i ? "transform translate-x-0" : "transform translate-x-full"}`}
          >
            <div className={"bg-white flex flex-col h-full"}>
              <div
                className={
                  "bg-gradient-to-r from-indigo-600 to-purple-600 p-4 md:p-5 text-center text-white flex-shrink-0"
                }
              >
                <img
                  src={"/Logo.webp"}
                  alt={"code bro , codebruh"}
                  className={"h-16 w-16 md:h-20 md:w-20 mx-auto mb-2"}
                />
                <h1 className={"text-lg md:text-xl font-bold"}>{"Welcome Back!"}</h1>
                <p className={"text-indigo-100 text-sm md:text-base mt-1"}>
                  {"Sign in to your account"}
                </p>
              </div>
              <div className={"flex-1 p-3 md:p-4 flex flex-col justify-center min-h-0"}>
                <div className={"flex-1 flex flex-col justify-center max-w-sm mx-auto w-full"}>
                  {m.general && (
                    <div
                      className={
                        "bg-red-50 border border-red-200 text-red-700 px-2 py-2 md:px-3 md:py-2 rounded-lg mb-4 text-xs animate-slideInLeft"
                      }
                    >
                      <div className={"flex items-center"}>
                        <svg
                          className={"w-3 h-3 mr-1 flex-shrink-0"}
                          fill={"currentColor"}
                          viewBox={"0 0 20 20"}
                        >
                          <path
                            fillRule={"evenodd"}
                            d={
                              "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                            }
                            clipRule={"evenodd"}
                          />
                        </svg>
                        {m.general}
                      </div>
                    </div>
                  )}
                  <form onSubmit={R} className={"space-y-5 mb-6"}>
                    <RegisterInput
                      type={"email"}
                      name={"email"}
                      placeholder={"Email Address"}
                      value={c.email}
                      onChange={M}
                      error={m.email}
                      icon={jsxRuntime.jsx(de, {})}
                    />
                    <RegisterInput
                      type={"password"}
                      name={"password"}
                      placeholder={"Password"}
                      value={c.password}
                      onChange={M}
                      error={m.password}
                      icon={<Me />}
                    />
                    <div className={"text-right pt-2"}>
                      <button
                        type={"button"}
                        onClick={te}
                        className={
                          "text-indigo-600 text-xs md:text-sm hover:text-indigo-800 hover:cursor-pointer transition-colors font-medium"
                        }
                      >
                        {"Forgot password?"}
                      </button>
                    </div>
                    <div className={"pt-3"}>
                      <button
                        type={"submit"}
                        disabled={x}
                        className={
                          "w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold py-3 md:py-3 px-4 rounded-full text-xs md:text-sm uppercase tracking-wider transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                        }
                      >
                        {x ? (
                          <div className={"flex items-center justify-center"}>
                            <svg
                              className={"animate-spin -ml-1 mr-2 h-3 w-3 md:h-4 md:w-4 text-white"}
                              fill={"none"}
                              viewBox={"0 0 24 24"}
                            >
                              <circle
                                className={"opacity-25"}
                                cx={"12"}
                                cy={"12"}
                                r={"10"}
                                stroke={"currentColor"}
                                strokeWidth={"4"}
                              />
                              <path
                                className={"opacity-75"}
                                fill={"currentColor"}
                                d={
                                  "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                }
                              />
                            </svg>
                            {"Signing In..."}
                          </div>
                        ) : (
                          "Sign In"
                        )}
                      </button>
                    </div>
                  </form>
                  <div className={"relative my-5"}>
                    <div className={"absolute inset-0 flex items-center"}>
                      <div className={"w-full border-t border-gray-300"} />
                    </div>
                    <div className={"relative flex justify-center text-xs md:text-sm"}>
                      <span className={"px-2 md:px-3 bg-white text-gray-500 font-medium"}>
                        {"Or continue with"}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={G}
                    className={
                      "w-full border-2 border-gray-200 rounded-lg md:rounded-xl py-3 md:py-3 px-2 md:px-3 flex items-center justify-center gap-2 hover:border-gray-300 hover:shadow-md transition-all duration-300 transform hover:scale-105 active:scale-95"
                    }
                  >
                    <svg className={"w-4 h-4 md:w-5 md:h-5"} viewBox={"0 0 24 24"}>
                      <path
                        fill={"#4285F4"}
                        d={
                          "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        }
                      />
                      <path
                        fill={"#34A853"}
                        d={
                          "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        }
                      />
                      <path
                        fill={"#FBBC05"}
                        d={
                          "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                        }
                      />
                      <path
                        fill={"#EA4335"}
                        d={
                          "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        }
                      />
                    </svg>
                    <span className={"text-gray-700 font-medium text-xs md:text-sm"}>
                      {"Continue with Google"}
                    </span>
                  </button>
                </div>
                <div
                  className={
                    "pt-6 pb-3 flex-shrink-0 bg-gray-50 mx-[-12px] md:mx-[-16px] px-3 md:px-4"
                  }
                >
                  <div className={"text-center"}>
                    <p className={"text-gray-600 text-sm md:text-base mb-2"}>
                      {"Don't have an account?"}
                    </p>
                    <button
                      onClick={() => l(false)}
                      className={
                        "text-indigo-600 font-bold text-sm md:text-base hover:text-indigo-800 transition-colors transform hover:scale-105 active:scale-95 px-6 py-2 rounded-full border-2 border-indigo-600 hover:bg-indigo-50"
                      }
                    >
                      {"Sign Up"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={"hidden xl:block h-full"}>
          <div
            className={`absolute top-0 h-full transition-all duration-700 ease-in-out left-0 w-1/2 ${i ? "opacity-0 z-10" : "transform translate-x-full opacity-100 z-50"}`}
          >
            <div
              className={
                "bg-white flex items-center justify-center flex-col px-10 h-full text-center"
              }
            >
              <h1 className={"text-4xl font-bold text-gray-800 mb-8"}>{"Create Account"}</h1>
              {y.general && (
                <div
                  className={
                    "bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-xl mb-6 w-full text-sm animate-slideInLeft"
                  }
                >
                  <div className={"flex items-center"}>
                    <svg
                      className={"w-4 h-4 mr-2 flex-shrink-0"}
                      fill={"currentColor"}
                      viewBox={"0 0 20 20"}
                    >
                      <path
                        fillRule={"evenodd"}
                        d={
                          "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        }
                        clipRule={"evenodd"}
                      />
                    </svg>
                    {y.general}
                  </div>
                </div>
              )}
              <form onSubmit={B} className={"w-full space-y-5"}>
                <RegisterInput
                  type={"text"}
                  name={"name"}
                  placeholder={"Full Name"}
                  value={g.name}
                  onChange={U}
                  error={y.name}
                  icon={<Ce />}
                />
                <RegisterInput
                  type={"tel"}
                  name={"phone"}
                  placeholder={"Phone Number"}
                  value={g.phone}
                  onChange={U}
                  error={y.phone}
                  icon={jsxRuntime.jsx(we, {})}
                />
                <RegisterInput
                  type={"email"}
                  name={"email"}
                  placeholder={"Email Address"}
                  value={g.email}
                  onChange={U}
                  error={y.email}
                  icon={jsxRuntime.jsx(de, {})}
                />
                <RegisterInput
                  type={"password"}
                  name={"password"}
                  placeholder={"Password"}
                  value={g.password}
                  onChange={U}
                  error={y.password}
                  icon={<Me />}
                />
                <RegisterInput
                  type={"password"}
                  name={"confirmPassword"}
                  placeholder={"Confirm Password"}
                  value={g.confirmPassword}
                  onChange={U}
                  error={y.confirmPassword}
                  icon={<Me />}
                />
                <button
                  type={"submit"}
                  disabled={N}
                  className={
                    "w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold py-4 px-8 rounded-full text-sm uppercase tracking-wider transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  }
                >
                  {N ? (
                    <div className={"flex items-center justify-center"}>
                      <svg
                        className={"animate-spin -ml-1 mr-3 h-5 w-5 text-white"}
                        fill={"none"}
                        viewBox={"0 0 24 24"}
                      >
                        <circle
                          className={"opacity-25"}
                          cx={"12"}
                          cy={"12"}
                          r={"10"}
                          stroke={"currentColor"}
                          strokeWidth={"4"}
                        />
                        <path
                          className={"opacity-75"}
                          fill={"currentColor"}
                          d={
                            "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }
                        />
                      </svg>
                      {"Creating Account..."}
                    </div>
                  ) : (
                    "Sign Up"
                  )}
                </button>
              </form>
            </div>
          </div>
          <div
            className={`absolute top-0 h-full transition-all duration-700 ease-in-out left-0 w-1/2 z-20 ${i ? "" : "transform translate-x-full"}`}
          >
            <div
              className={
                "bg-white flex items-center justify-center flex-col px-10 h-full text-center"
              }
            >
              <img src={"/Logo.webp"} alt={"code bro , codebruh"} className={"h-30 w-30 mb-6"} />
              <h1 className={"text-3xl font-bold text-gray-800 mb-8"}>{"Sign In"}</h1>
              {m.general && (
                <div
                  className={
                    "bg-red-50 border border-red-300 text-red-700 px-4 py-3 rounded-xl mb-6 w-full text-sm animate-slideInLeft"
                  }
                >
                  <div className={"flex items-center"}>
                    <svg
                      className={"w-4 h-4 mr-2 flex-shrink-0"}
                      fill={"currentColor"}
                      viewBox={"0 0 20 20"}
                    >
                      <path
                        fillRule={"evenodd"}
                        d={
                          "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        }
                        clipRule={"evenodd"}
                      />
                    </svg>
                    {m.general}
                  </div>
                </div>
              )}
              <form onSubmit={R} className={"w-full space-y-6"}>
                <RegisterInput
                  type={"email"}
                  name={"email"}
                  placeholder={"Email Address"}
                  value={c.email}
                  onChange={M}
                  error={m.email}
                  icon={jsxRuntime.jsx(de, {})}
                />
                <RegisterInput
                  type={"password"}
                  name={"password"}
                  placeholder={"Password"}
                  value={c.password}
                  onChange={M}
                  error={m.password}
                  icon={<Me />}
                />
                <button
                  type={"button"}
                  onClick={te}
                  className={
                    "text-indigo-600 text-sm hover:text-indigo-800 transition-colors block ml-auto font-medium"
                  }
                >
                  {"Forgot your password?"}
                </button>
                <button
                  type={"submit"}
                  disabled={x}
                  className={
                    "w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold py-4 px-8 rounded-full text-sm uppercase tracking-wider transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  }
                >
                  {x ? (
                    <div className={"flex items-center justify-center"}>
                      <svg
                        className={"animate-spin -ml-1 mr-3 h-5 w-5 text-white"}
                        fill={"none"}
                        viewBox={"0 0 24 24"}
                      >
                        <circle
                          className={"opacity-25"}
                          cx={"12"}
                          cy={"12"}
                          r={"10"}
                          stroke={"currentColor"}
                          strokeWidth={"4"}
                        />
                        <path
                          className={"opacity-75"}
                          fill={"currentColor"}
                          d={
                            "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }
                        />
                      </svg>
                      {"Signing In..."}
                    </div>
                  ) : (
                    "Sign In"
                  )}
                </button>
              </form>
              <div className={"relative w-full my-8"}>
                <div className={"absolute inset-0 flex items-center"}>
                  <div className={"w-full border-t border-gray-300"} />
                </div>
                <div className={"relative flex justify-center text-sm"}>
                  <span className={"px-4 bg-white text-gray-500 font-medium"}>
                    {"Or continue with"}
                  </span>
                </div>
              </div>
              <button
                onClick={G}
                className={
                  "w-full border-2 border-gray-200 rounded-xl py-4 px-4 flex items-center justify-center gap-3 hover:border-gray-300 hover:shadow-md transition-all duration-300 transform hover:scale-105 active:scale-95"
                }
              >
                <svg className={"w-5 h-5"} viewBox={"0 0 24 24"}>
                  <path
                    fill={"#4285F4"}
                    d={
                      "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    }
                  />
                  <path
                    fill={"#34A853"}
                    d={
                      "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    }
                  />
                  <path
                    fill={"#FBBC05"}
                    d={
                      "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    }
                  />
                  <path
                    fill={"#EA4335"}
                    d={
                      "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    }
                  />
                </svg>
                <span className={"text-gray-700 font-medium"}>{"Continue with Google"}</span>
              </button>
            </div>
          </div>
          <div
            className={`absolute top-0 left-1/2 w-1/2 h-full overflow-hidden transition-transform duration-700 ease-in-out z-100 ${i ? "" : "transform -translate-x-full"}`}
          >
            <div
              className={`bg-gradient-to-r from-indigo-600 to-purple-600 relative -left-full h-full w-[200%] transform transition-transform duration-700 ease-in-out ${i ? "translate-x-0" : "translate-x-1/2"}`}
            >
              <div
                className={`absolute flex items-center justify-center flex-col px-10 text-center top-0 h-full w-1/2 transform transition-transform duration-700 ease-in-out ${i ? "-translate-x-1/5" : "translate-x-0"}`}
              >
                <img src={"/Logo.webp"} alt={"code bro , codebruh"} className={"h-30 w-30 mb-6"} />
                <h1 className={"text-4xl font-bold text-white mb-6"}>{"Welcome Back!"}</h1>
                <p className={"text-white/90 text-lg leading-relaxed mb-10 px-6"}>
                  {"To keep connected with us please login with your personal info"}
                </p>
                <button
                  onClick={() => l(true)}
                  className={
                    "bg-transparent border-2 border-white text-white hover:bg-white hover:text-indigo-600 font-bold py-4 px-10 rounded-full text-sm uppercase tracking-wider transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none"
                  }
                >
                  {"Sign In"}
                </button>
              </div>
              <div
                className={`absolute right-0 flex items-center justify-center flex-col px-10 text-center top-0 h-full w-1/2 transform transition-transform duration-700 ease-in-out ${i ? "translate-x-0" : "translate-x-1/5"}`}
              >
                <h1 className={"text-4xl font-bold text-white mb-6"}>{"Hello, Friend!"}</h1>
                <p className={"text-white/90 text-lg leading-relaxed mb-10 px-6"}>
                  {"Enter your personal details and start your journey with us"}
                </p>
                <button
                  onClick={() => l(false)}
                  className={
                    "bg-transparent border-2 border-white text-white hover:bg-white hover:text-indigo-600 font-bold py-4 px-10 rounded-full text-sm uppercase tracking-wider transition-all duration-300 transform hover:scale-105 active:scale-95 focus:outline-none"
                  }
                >
                  {"Sign Up"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export { RegisterForm };
